import React, { useEffect } from "react";

// function createProxy(content) {
//   console.log(content);
//   return new Proxy(content, {
//     set: function(target, key, value) {
//       console.log(target);
//       return value;
//     },
//     get: function(target, key, value) {
//       console.log('getter');
//     }
//   })
// }

const DateWrapper = ({ date }) => {
  return (
    <div className="date-wrapper">
      <div className="deco-container">
        <span className="deco left" />
      </div>
      <h2 className="date-content">{date}</h2>
      <div className="deco-container">
        <span className="deco right" />
      </div>
    </div>
  );
};

const PcProgram = ({tableInfo = []}) => (
  <div className="pc-table-container">
    {tableInfo.map((table, index) => (
        <div className="program-table" key={index}>
          <DateWrapper date={table.time} />
          <div className="program-row program-table-header">
            {table.headerList.map((col, index) => (
              <div
                className={`program-col program-col-${col.flex || 1}`}
                key={index}
              >
                <div className="content">{col.text}</div>
              </div>
            ))}
          </div>
          {table.list.map((row, index) => (
            <div
              className={`program-row ${row.isBreak ? "break" : ""}`}
              key={index}
            >
              {row.col.map((col) => (
                <div
                  className={`program-col program-col-${col.flex || 1}`}
                  key={col.text}
                >
                  <div className="content">{col.text}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
  </div>
)

const MobileProgram = ({tableInfo = {}}) => {
  // let proxy = [];
  // useEffect(() => {
  //   const timeCol = document.getElementsByClassName('program-col-2');
  //   for(let i = 0; i < timeCol.length; i++) {
  //     proxy.push(createProxy(timeCol[i].children[0]));
  //   }
  //   proxy[0].offsetHeight = 0
  //   console.log();
  //   console.log(timeCol[0].children[0].style)
  // }, [])
  return (
    <div className="mobile-table-container">
      {tableInfo.map((table, index) => (
          <div className="program-table" key={index}>
            <DateWrapper date={table.time} />
            <div className="program-row program-table-header">
              {table.headerList.map((col, index) => (
                <div
                  className={`program-col program-col-${col.flex || 1}`}
                  key={index}
                >
                  <div className="content" dangerouslySetInnerHTML={{ __html: col.text}}></div>
                </div>
              ))}
            </div>
            {table.list.map((row, index) => (
              <div
                className={`program-row ${row.isBreak ? "break" : ""}`}
                key={index}
              >
                {row.col.map((col) => (
                  <div
                    className={`program-col program-col-${col.flex || 1}`}
                    key={col.text}
                  >
                    <div className="content">{col.text}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
    </div>
  )
}

const Program = ({ message = {} }) => (
  <section id="program" className="program">
    <div className="content">
      <div className="section-title">{message.title}</div>
      <PcProgram tableInfo={message.pcTableInfo} />
      <MobileProgram tableInfo={message.mobileTableInfo} />
    </div>
  </section>
);

export default Program;
